import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { supabase } from '@/lib/supabase';

const VACATION_NOTICE = {
  title: 'Wir machen Urlaub!',
  description:
    'Vom 22. bis 26. Mai 2026 ist unser Restaurant wegen Betriebsurlaub geschlossen. Ab dem 27. Mai freuen wir uns wieder, Sie bei uns begrüßen zu dürfen. Buon riposo – bis bald!',
};

function isVacationPeriod() {
  const now = new Date();
  const start = new Date('2026-05-22T00:00:00');
  const end = new Date('2026-05-26T23:59:59');
  return now >= start && now <= end;
}

export default function VacationBanner() {
  const [notice, setNotice] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isVacationPeriod()) {
      setNotice(VACATION_NOTICE);
      return;
    }
    supabase
      .from('vacation_notice')
      .select('*')
      .eq('id', 1)
      .single()
      .then(({ data }) => {
        if (data && data.active && data.title) {
          setNotice(data);
        }
      });
  }, []);

  if (!notice || dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        key="vacation-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center px-4"
        style={{ backgroundColor: 'rgba(44, 51, 37, 0.75)' }}
        onClick={() => setDismissed(true)}
      >
        <motion.div
          key="vacation-modal"
          initial={{ opacity: 0, scale: 0.92, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.92, y: 20 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          onClick={(e) => e.stopPropagation()}
          className="relative bg-cream w-full max-w-lg shadow-2xl px-8 py-10 text-center"
        >
          {/* Schließen-Button */}
          <button
            onClick={() => setDismissed(true)}
            aria-label="Schließen"
            className="absolute top-4 right-4 text-olive-900/40 hover:text-olive-900 transition-colors"
          >
            <X size={20} />
          </button>

          {/* Dekorative Linie oben */}
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-12 bg-terracotta" />
            <span className="font-accent text-terracotta text-2xl">Il Girasole</span>
            <div className="h-px w-12 bg-terracotta" />
          </div>

          {/* Titel */}
          <h2 className="font-heading text-2xl sm:text-3xl text-olive-900 mb-4 leading-snug">
            {notice.title}
          </h2>

          {/* Beschreibung (optional) */}
          {notice.description && (
            <p className="font-body text-olive-900/70 text-sm sm:text-base leading-relaxed mb-6">
              {notice.description}
            </p>
          )}

          {/* Dekorative Linie unten */}
          <div className="h-px bg-olive-900/10 my-6" />

          <button
            onClick={() => setDismissed(true)}
            className="font-body uppercase text-xs tracking-widest px-8 py-3 bg-olive-900 text-cream hover:bg-olive-900/80 transition-colors"
          >
            Verstanden
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
